module.exports = [{
		id1: 1,
		num: "1",
		icon: "el-icon-s-custom",
		name1: "老人管理",
		children: [{
			path: "/",
			name: "老人数据列表"
		}]
	},
	{
		id1: 2,
		num: "2",
		icon: "el-icon-s-data",
		name1: "数据管理",
		children: [{
			path: "/health-list",
			name: "健康数据列表"
		}, {
			path: "/bed-list",
			name: "床位设备列表"
		}, {
			path: "/position-list",
			name: "定位数据列表"
		}]
	},
	{
		id1: 3,
		num: "3",
		icon: "el-icon-document",
		name1: "接口文档",
		children: [{
			path: "/gain-token",
			name: "获取token"
		}, {
			path: "/add-older",
			name: "添加老人"
		}, {
			path: "/add-oldPosition",
			name: "添加老人定位数据"
		}, {
			path: "/add-surveyData",
			name: "添加监测数据"
		}]
	},
	{
		id1: 4,
		num: "4",
		icon: "el-icon-suitcase-1",
		name1: "表单设计",
		children: [{
			path: "/admin",
			name: "服务人员"
		},{
			path: "/form-data",
			name: "模板列表"
		},{
			path: "/form-list",
			name: "表单列表"
		}]
	}
]
